import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "d-flex align-items-start" }
const _hoisted_2 = /*#__PURE__*/_createVNode("i", { class: "pi pi-chevron-left mr-1" }, null, -1)
const _hoisted_3 = { class: "mt-2" }
const _hoisted_4 = { class: "ml-auto d-flex align-items-center" }
const _hoisted_5 = { class: "d-flex align-items-baseline justify-content-between" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 1,
  class: "no-messages text-center"
}
const _hoisted_8 = { class: "text-uppercase" }
const _hoisted_9 = {
  key: 0,
  class: "fs-18 text-gray"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_Button = _resolveComponent("Button")
  const _component_TabPanel = _resolveComponent("TabPanel")
  const _component_TabView = _resolveComponent("TabView")
  const _component_MessageItem = _resolveComponent("MessageItem")
  const _component_ElScrollbar = _resolveComponent("ElScrollbar")
  const _component_DialogAddEditMessage = _resolveComponent("DialogAddEditMessage")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("header", null, [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", null, [
          _createVNode(_component_router_link, {
            to: _ctx.backLink,
            class: "fs-18 text-decoration-none text-gray"
          }, {
            default: _withCtx(() => [
              _hoisted_2,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("general.backTo")) + ": " + _toDisplayString(_ctx.currentEntrancePlant.name), 1)
            ]),
            _: 1
          }, 8, ["to"]),
          _createVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t("AppResourceEP.Messages")), 1)
        ]),
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_Button, {
            class: "p-button-rounded p-button-raised p-button--m",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleAddEditMessage()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("AppResourceEP.NewGateMessage")), 1)
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createVNode("div", _hoisted_5, [
      _createVNode(_component_TabView, {
        class: "messages-list p-tabview--custom",
        onTabChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleTabClick($event)))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_TabPanel, {
            header: _ctx.$t('AppResourceEP.ActiveMessage')
          }, null, 8, ["header"]),
          _createVNode(_component_TabPanel, {
            header: _ctx.$t('AppResourceEP.ExpiredMessages')
          }, null, 8, ["header"])
        ]),
        _: 1
      })
    ]),
    (_ctx.messagesList.length > 0)
      ? (_openBlock(), _createBlock("div", _hoisted_6, [
          _createVNode(_component_ElScrollbar, { class: "message-card-list" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.messagesList, (message) => {
                return (_openBlock(), _createBlock(_component_MessageItem, {
                  key: message.id,
                  message: message,
                  plantGates: _ctx.gatesWithPE,
                  onEditMessage: _ctx.toggleAddEditMessage,
                  onDeleteMessage: _ctx.handleDeleteMessage,
                  expired: _ctx.tabSelected === _ctx.MessagesTab.expired
                }, null, 8, ["message", "plantGates", "onEditMessage", "onDeleteMessage", "expired"]))
              }), 128))
            ]),
            _: 1
          })
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_7, [
          _createVNode("h1", _hoisted_8, _toDisplayString(_ctx.$t("entrancePlant.noMessages")), 1),
          (_ctx.tabSelected === _ctx.MessagesTab.active)
            ? (_openBlock(), _createBlock("span", _hoisted_9, _toDisplayString(_ctx.$t("entrancePlant.hintNewMessage")), 1))
            : _createCommentVNode("", true)
        ])),
    _createVNode(_component_DialogAddEditMessage, {
      messageToEdit: _ctx.messageToEdit,
      isVisible: _ctx.isVisibleAddEditMessage,
      onHideDialog: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggleAddEditMessage())),
      onUpdateList: _ctx.handleUpdateList
    }, null, 8, ["messageToEdit", "isVisible", "onUpdateList"])
  ], 64))
}